// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2mDGQ","tab":"ProcedureTabs_tab__ikz-1"};